module.exports = __webpack_public_path__ + "static/img/Lachlan-Carmichael.e08fdfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachlan-Carmichael.jpg
// module id = 0H2n
// module chunks = 0